module.exports = __webpack_public_path__ + "static/media/to_green.9a574453.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/to_green.svg
// module id = 385
// module chunks = 0